import { FuelCheckbox } from '@frete.com/fuel-react';
import styled from 'styled-components';

export const Checkbox = styled(FuelCheckbox)`
  margin: ${({ theme }) => theme.spacing.km4} ${({ theme }) => theme.spacing.km0};
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.spacing.km4};
`;
